import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import * as SockJS from 'sockjs-client';
import {SERVER_API_URL} from 'src/app/app.constants';
import {createRequestOption} from 'src/app/shared/util/request-util';
import * as Stomp from 'stompjs';
import {StateStorageService} from '../core/auth/state-storage.service';
import {CertificateRequestDataPreFill} from '../core/certificate/certificate-request-prefill.service';
import {LoginService} from '../core/login/login.service';
import {MessageConst} from './constants/message.constants';
import {INotification} from './model/notification.model';
import {RouterExtService} from './router-ext-service';
import {CommonUtils} from './util/common-utils';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {
  private stompClient;
  private serverUrl=SERVER_API_URL+'socket'
  private serverUrlForData=SERVER_API_URL+'api/';
  private notificationUrl=SERVER_API_URL+"api/notification/";


  public loginService: LoginService;
  constructor(private http: HttpClient,
    private routerExtService: RouterExtService,
    private router: Router,
    private stateStorageService: StateStorageService,
    private certificateRequestDataPreFill: CertificateRequestDataPreFill,
  ) {}
  setLoginService(loginService) {
    this.loginService=loginService;
  }

  connectSocket() {
    let ws=new SockJS(this.serverUrl);
    this.stompClient=Stomp.over(ws);
    return this.stompClient;
  }
  disconnectSocket() {
    if(this.stompClient) {
      this.stompClient.disconnect();
    }
    
  }

  


  findAllByLogInUser(req: any): Observable<HttpResponse<any>> {

    const options=createRequestOption(req);
    return this.http.get<any>(`${this.serverUrlForData+'notification'}`,{params: options,observe: 'response'});
  
  }
  
  findAll(flag: boolean,req: any): Observable<HttpResponse<any>> {

    const options=createRequestOption(req);
    return this.http.get<any>(`${this.serverUrlForData+'notification/'+flag}`,{params: options,observe: 'response'});
    
  }
  

  findTop10ByLogInUser() {
    return this.http
      .get<any>(this.serverUrlForData+"top-ten-notification",{observe: 'response'})
  }

  getCountByUser() {
    return this.http
      .get<any>(this.serverUrlForData+"notification-count",{observe: 'response'})
  }

  markReadAllByUser() {
    return this.http
      .get<any>(this.serverUrlForData+"mark-read-notification-all",{observe: 'response'})
  }
  
  markAsRead(notificationId) {
    return this.http
      .get<any>(this.serverUrlForData+"mark-read-notification/"+notificationId,{observe: 'response'})
  }


  navigateToNotification(notification: INotification) {
        
    if(notification.navigateUrl=="") {
      this.markAsRead(notification.id).subscribe(data => {
        console.log(data);
        this.notificationMessagesAndCount();
        this.router.navigateByUrl("/notification/read");
      })
      return;
    }

    // if(this.loginService.notificationCount&&!notification.isRead) {
    if(!notification.isRead) {
      this.markAsRead(notification.id).subscribe(data => {
        console.log(data);
        this.notificationMessagesAndCount();
            
      })
    }

    if(notification.navigateUrl.includes('loss-payee/')) {
      if(notification.navigateUrl.includes('/request')) {
        this.router.navigateByUrl("/"+notification.navigateUrl);
      }

    }
   
    /* "RE_EVALUATION_FOR_FAILED_CERTIFICATE_REQUEST" */
    if(notification.notificationTriggerPoint&&notification.notificationTriggerPoint=="RE_EVALUATION_FOR_FAILED_CERTIFICATE_REQUEST") {
      this.viewCertificateFavouriteRequest(notification.notificationTypeId);
    } else if(notification.notificationTriggerPoint&&notification.notificationTriggerPoint=="RE_EVALUATION_FOR_FAILED_DECLARATION_REQUEST") {
      this.viewBulkCertificateFavouriteRequest(notification.notificationTypeId);
    } else {

      this.router.navigateByUrl('',{skipLocationChange: true}).then(() => this.router.navigateByUrl("/"+notification.navigateUrl));
    }
  }

  getById(url?: any,req?: any): Observable<any> {
    const options=createRequestOption(req);
    return this.http
      .get(SERVER_API_URL+url,{params: options,observe: 'response'})
      .map((res: any) => this.convertDateArrayFromServer(res));
  }
  private convertDateArrayFromServer(res: any): any {
    return res.body;
  }

  viewBulkCertificateFavouriteRequest(certificateRequestId: any) {
    let url="api/declaration/"+certificateRequestId;
    this.getById(url).subscribe(res => {
      if(CommonUtils.isSame(res.status, MessageConst.SUCCESS)) {
        let request=res.payload;
        request.id=null;
        request.certificateRequestNumber=null;
        this.stateStorageService.storeBulkCertificateDTO(request);
        this.router.navigateByUrl('/my-declaration/declare-shipment');
      } else {
        // this.jhiAlertService.error("Sorry,  you don't have any active Policy!", null, null);
      }
    });
  }


  viewCertificateFavouriteRequest(certificateRequestId: number) {
    this.certificateRequestDataPreFill.viewCertificateRequest(certificateRequestId,true,true,true);
  }

  notificationMessagesAndCount() {
    this.getCountByUser().subscribe(res => {
      this.loginService.notificationCount=res.body;
    
    })
    this.getMessages();
  }
  getMessages() {
    this.findTop10ByLogInUser().subscribe(response => {
      this.loginService.messages=response.body;
    })
  }
}
